import { ApiModel, ApiModelOptions } from "../../../ApiModel";
import { VerificationModel } from "../../../models";
import { JsonApiManyResponse } from "../../../types";

export default function apiVerificationModel(
  opts: ApiModelOptions<VerificationModel>,
) {
  const model = ApiModel<VerificationModel>("verification", opts);

  const getVerificationsByAccountId = async (accountId: string | number) => {
    return await model.handler.apiRequest<
      JsonApiManyResponse<VerificationModel>
    >(`/verifications/account/${accountId}`, "GET");
  };

  const getVerificationsByAccountIdAndType = async (
    accountId: string | number,
    type: "accreditation" | "identity",
  ) => {
    return await model.handler.apiRequest<
      JsonApiManyResponse<VerificationModel>
    >(`/verifications/account/${accountId}/${type}`, "GET");
  };

  return {
    ...model,
    getVerificationsByAccountId,
    getVerificationsByAccountIdAndType,
  };
}
